var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{directives:[{name:"insertbmp",rawName:"v-insertbmp",value:(_vm.bmp),expression:"bmp"}],attrs:{"height":_vm.height ? _vm.height : 150,"width":_vm.width ? _vm.width : _vm.bmp.sizeX == 8 ? 150 : 230}})
}
var staticRenderFns = []

export { render, staticRenderFns }